import React from 'react';
import DOMPurify from 'dompurify';

interface SafeHTMLProps {
  html: string;
  tag?: keyof JSX.IntrinsicElements;
  removeLayoutStyles?: boolean;
  [key: string]: any;
}

const SafeHTML: React.FC<SafeHTMLProps> = ({ html, tag = 'div', removeLayoutStyles = false, ...props }) => {
  let processedHTML = html;

  if (removeLayoutStyles) {
    processedHTML = html
      .replace(/text-align:\s*[^;]*;?/gi, '')
      .replace(/list-style:\s*[^;]*;?/gi, '')
      .replace(/style="[;\s]*"/gi, '')
      .replace(/<li><p[^>]*>/gi, '<li>')
      .replace(/<\/p><\/li>/gi, '</li>')
      .replace(/\s+/g, ' ')
      .trim();
  }

  const cleanHTML = DOMPurify.sanitize(processedHTML, {
    ADD_TAGS: ['sup'],
    ADD_ATTR: ['target'],
  });

  return React.createElement(tag, { dangerouslySetInnerHTML: { __html: cleanHTML }, ...props });
};

export default SafeHTML;
